import { Card, Dropdown, Tag, Tooltip } from 'antd';
import React from 'react';
import { ReactComponent as MoreIcon } from '../../../assets/svg/ellipsis-vertical-solid.svg';
import {
  ACTIONS,
  DATE_FORMATS,
  EXPORT,
  EXPORT_JOBS_STATUS,
} from '../../../common/constants';
import {
  formatDate,
  getExportDownloadTooltip,
  getExportFileUrls,
  isExportDownloadDisabled,
} from '../../../common/utils';

const ExportCard = ({ exportItem, handleDownload, infiniteScrollRef }) => {
  const isDownloadDisabled = isExportDownloadDisabled(exportItem);
  const tooltipTitle = getExportDownloadTooltip(exportItem);

  const items = [
    {
      label: tooltipTitle ? (
        <Tooltip title={tooltipTitle} placement="top" zIndex={4}>
          <span>{ACTIONS?.DOWNLOAD?.label}</span>
        </Tooltip>
      ) : (
        ACTIONS?.DOWNLOAD?.label
      ),
      key: ACTIONS?.DOWNLOAD?.value,
      disabled: isDownloadDisabled,
    },
  ];

  const menuProps = {
    items,
    onClick: () => {
      if (isDownloadDisabled) {
        return;
      }
      getExportFileUrls(exportItem)?.forEach((url) => handleDownload(url));
    },
  };

  return (
    <Card
      className="ml-12 mr-12 mb-24 mt-12 mobile-card"
      title={EXPORT?.[exportItem?.type]}
      extra={
        <div className="d-flex align-center">
          <Tag
            color={EXPORT_JOBS_STATUS?.[exportItem?.status]?.color}
            className="mr-16"
          >
            {EXPORT_JOBS_STATUS?.[exportItem?.status]?.text}
          </Tag>
          <Dropdown
            getPopupContainer={(trigger) => trigger?.parentNode}
            menu={menuProps}
          >
            <MoreIcon className="pointer mobile-svg-icon" />
          </Dropdown>
        </div>
      }
      ref={infiniteScrollRef}
    >
      <div className="mb-8">
        <span className="mobile-card-label">Date: </span>
        <span>
          {formatDate(exportItem?.createdAt, DATE_FORMATS?.REGULAR) ||
            'No Date'}
        </span>
      </div>
      <div className="mb-8">
        <span className="mobile-card-label">Library Number:</span>
        <span>{exportItem?.filter?.libraryNumber || 'No data'}</span>
      </div>
    </Card>
  );
};

export default ExportCard;
